import React from 'react';
import styled from 'styled-components';
import { gray1, gray7, gray4 } from '../globals/colors';
import { font } from '../globals/fonts';

var spacing = '1em';

/**
 * @example
 * <WidgetTable>
 *     <WidgetTable_Head>
 *         <WidgetTable_Row>
 *             <WidgetTableHeader>Column Title</WidgetTableHeader>
 *         </WidgetTable_Row>
 *     </WidgetTable_Head>
 *     <WidgetTable_Body>
 *         <WidgetTable_Row>
 *             <WidgetTable_Cell>Cell Value</WidgetTable_Cell>
 *         </WidgetTable_Row>
 *     </WidgetTable_Body>
 * </WidgetTable>
 */
export var WidgetTable = styled.table.attrs(function () {return {
    cellSpacing: 0
  };}).withConfig({ displayName: "WidgetTablestyle__WidgetTable", componentId: "sc-1g1clpx-0" })(["font-size:inherit;font-family:", ";background:", ";width:100%;padding:0 ", ";color:", ";"],

font.light,
gray1,

spacing,
gray7);


export var WidgetTable_Head = styled.thead.withConfig({ displayName: "WidgetTablestyle__WidgetTable_Head", componentId: "sc-1g1clpx-1" })([""]);
export var WidgetTable_Header = styled.th.withConfig({ displayName: "WidgetTablestyle__WidgetTable_Header", componentId: "sc-1g1clpx-2" })([""]);
export var WidgetTable_Row = styled.tr.withConfig({ displayName: "WidgetTablestyle__WidgetTable_Row", componentId: "sc-1g1clpx-3" })([""]);

/**
 * @typedef WidgetTableCellProps
 * @property {boolean} [alignRight]
 * @property {React.ReactNode} [children]
 */

/** @param {WidgetTableCellProps & React.HTMLAttributes<HTMLTableCellElement>} props> */
var widgetTableCellAttrsFn = function widgetTableCellAttrsFn(props) {return {
    children: /*#__PURE__*/React.createElement("div", { className: "widget-table-cell-content" }, props.children)
  };};

/** @param {WidgetTableCellProps & React.HTMLAttributes<HTMLTableCellElement>} props */
var alignRightFn = function alignRightFn(props) {return props.alignRight ? 'flex-end' : null;};

/** @type {import('styled-components').StyledComponent<'td', any, WidgetTableCellProps, any>} */
export var WidgetTable_Cell = styled.td.attrs(widgetTableCellAttrsFn).withConfig({ displayName: "WidgetTablestyle__WidgetTable_Cell", componentId: "sc-1g1clpx-4" })(["border-top:1px solid ", ";padding:", ";&:first-of-type{padding-left:0;}&:last-of-type{padding-right:0;}& > .widget-table-cell-content{display:flex;align-items:center;justify-content:", ";}"],
gray4,
spacing,











alignRightFn);



export var WidgetTable_Body = styled.tbody.withConfig({ displayName: "WidgetTablestyle__WidgetTable_Body", componentId: "sc-1g1clpx-5" })(["", ":first-of-type ", "{border-top:0;}"],

WidgetTable_Row, WidgetTable_Cell);
//# sourceMappingURL=WidgetTable.style.js.map